import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { getTag, getTagsByPlant } from '../../../../../services/tagsService';
import { LoadingSpan } from '../../../Loadings/loadingSpan';
import { KTSVG } from '../../../../../../_metronic/helpers';
import { ModalAddUpdateTag } from '../../../../tagsUsinas/components/ModalAddEditTag';
import { SearchInput } from '../../../SearchInput';
import { useToast } from '../../../Toats';

export function TagsPlant({data}: any) {
    const { toggleToast } = useToast();
    const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
    const [myTag, setMyTag] = useState<any | null>(null)
    const [mySearch, setMySearch] = useState<any[]>([]);
    const [control, setControl] = useState(false);

    const { data: tags = [], isLoading: loading, refetch } = useQuery(
        ["getTagsByPlant", data && data.id ? data.id : null],
        async () => {
            const tags = await getTagsByPlant(data && data.id ? data.id : "")
            return tags;
        },
        {
          enabled: !!(data && data.id),
          onError: (error) => {
            console.log(error);
          },
        }
    )

    const tagsList = control ? mySearch : tags;
    const activeTags = (tagsList || []).filter((tag: any) => tag.status === 'ATIVO')
    const inactiveTags = (tagsList || []).filter((tag: any) => tag.status !== 'ATIVO')

    const renderTagBadge = (tag: any, inactive = false) => (
        <span
            key={tag.id}
            onClick={() => handleTagClick(tag)}
            className='badge'
            role='button'
            title={tag.description || 'Sem descrição'}
            style={{
                backgroundColor: tag.color,
                color: '#fff',
                cursor: 'pointer',
                opacity: inactive ? 0.55 : 1,
            }}
        >
            {tag.name}
        </span>
    )

    const handleTagClick = async (tag: any) => {
        try {
            const fullTag = await getTag(tag.id)
            fullTag.idsPlants = fullTag.plants && fullTag.plants.length > 0
                ? fullTag.plants.map((plant: any) => plant.id)
                : []
            setMyTag(fullTag)
            setShowCreateAppModal(true)
        } catch (error) {
            console.log(error)
            toggleToast("Erro ao buscar a tag. ", "error")
        }
    }

    return (
        <div className='d-flex flex-column' style={{height: '35rem'}}>
            <div
                className='d-flex align-items-center justify-content-between rounded flex-wrap'
                style={{gap: '1rem', padding: '0.85rem 1rem', background: 'var(--bs-gray-100)'}}
            >
                {/* <h3 className='card-title d-flex align-items-start flex-column mb-0'>
                    <span className='card-label fw-bold fs-5 mb-1'>Tags</span>
                    <span className='text-muted fw-semibold fs-7'>Tags vinculadas a essa usina</span>
                </h3> */}

                <SearchInput
                    className='form-control form-control-sm form-control-solid bg-body'
                    placeholder='Buscar tag'
                    myDate={tags}
                    setMySearch={setMySearch}
                    control={control}
                    style={{flex: '1'}}
                    setControl={setControl}
                    searchParameter="name"
                />

                <a
                    onClick={() => {
                        setMyTag(null)
                        setShowCreateAppModal(true)
                    }}
                    href='#'
                    className='btn btn-sm btn-light-primary'
                >
                    <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                    Nova Tag
                </a>
            </div>

            <div
                className='border border-gray-300 border-dashed rounded py-3 px-4 mt-3 flex-1'
                style={{flex: '1', overflowY: 'auto', height: '90%'}}
            >
                {loading ? (
                    <div className='d-flex justify-content-center' style={{padding: '2rem'}}>
                        <LoadingSpan />
                    </div>
                ) : tagsList && tagsList.length > 0 ? (
                    <div className='d-flex flex-column' style={{gap: '1.25rem'}}>
                        <div>
                            <div
                                className='d-flex align-items-center mb-2 rounded'
                                style={{gap: '0.5rem', padding: '0.45rem 0.75rem', background: 'var(--bs-gray-100)'}}
                            >
                                <span className='text-dark fw-bold fs-7'>Ativas</span>
                                <span className='badge badge-light-success'>{activeTags.length}</span>
                            </div>
                            <div className='d-flex flex-wrap' style={{gap: '0.5rem'}}>
                                {activeTags.length > 0 ? (
                                    activeTags.map((tag: any) => renderTagBadge(tag))
                                ) : (
                                    <span className='text-muted fw-semibold fs-7'>Nenhuma tag ativa.</span>
                                )}
                            </div>
                        </div>

                        <div>
                            <div
                                className='d-flex align-items-center mb-2 rounded'
                                style={{gap: '0.5rem', padding: '0.45rem 0.75rem', background: 'var(--bs-gray-100)'}}
                            >
                                <span className='text-dark fw-bold fs-7'>Inativas</span>
                                <span className='badge badge-light-danger'>{inactiveTags.length}</span>
                            </div>
                            <div className='d-flex flex-wrap' style={{gap: '0.5rem'}}>
                                {inactiveTags.length > 0 ? (
                                    inactiveTags.map((tag: any) => renderTagBadge(tag, true))
                                ) : (
                                    <span className='text-muted fw-semibold fs-7'>Nenhuma tag inativa.</span>
                                )}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div
                        className='bg-light'
                        style={{
                            width: '100%',
                            height: '100%',
                            minHeight: '12rem',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '0.5rem',
                            flexDirection: 'column',
                        }}
                    >
                        <KTSVG
                            path='/media/icons/duotune/general/gen004.svg'
                            className='svg-icon-3x me-1'
                        />
                        <h3 className='card-title d-flex align-items-center justify-content-center flex-column mb-0'>
                            <span className='text-muted fw-semibold fs-7'>Nenhuma tag vinculada.</span>
                        </h3>
                    </div>
                )}
            </div>

            <ModalAddUpdateTag
                show={showCreateAppModal}
                id={myTag ? myTag.id : undefined}
                data={myTag ? myTag : (data && data.id ? {idsPlants: [data.id]} as any : undefined)}
                handleClose={() => {
                    setMyTag(null)
                    setShowCreateAppModal(false)
                    refetch()
                }}
            />
        </div>
    )
}
